import React, { useState, useRef } from "react";

const HOLD_DURATION = 20; // ms required to trigger checkout

const Checkout = ({beads}) => {
  const [holding, setHolding] = useState(false);
  const [ready, setReady] = useState(false);
  const timerRef = useRef(null);
  const formRef = useRef(null);

  const startHold = () => {
    setHolding(true);
    timerRef.current = setTimeout(() => {
      setReady(true);
      formRef.current.submit(); // triggers actual form submit
    }, HOLD_DURATION);
  };

  const cancelHold = () => {
    setHolding(false);
    clearTimeout(timerRef.current);
  };

  return (
    <div className="checkoutDiv">
      <form ref={formRef} action="/api/create-checkout" method="POST">
        <input type="hidden" name="beads" value={beads} />
        <button
          className={`checkoutButton ${holding ? "holding" : ""}`}
          type="button" 
          onMouseDown={startHold}
          onMouseUp={cancelHold}
          onMouseLeave={cancelHold}
          onTouchStart={startHold}
          onTouchEnd={cancelHold}
        >
          {ready ? "Processing…" : holding ? "Keep holding…" : "Checkout"}
        </button>
      </form>
    </div>
  );
};

export default Checkout;
